import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const userInfo = JSON.parse(localStorage.getItem('userInfo'));

  if (!userInfo) {
    return <Navigate to='/login' replace />;
  }

  // If user must change password, redirect to profile
  if (userInfo.mustChangePassword) {
    return <Navigate to='/profile' replace />;
  }

  // If user is admin, redirect to admin dashboard
  if (userInfo.role === 'ADMIN') {
    return <Navigate to='/admin/farmers' replace />;
  }

  // If user is logged in and not admin (i.e., farmer), allow access
  return <Outlet />;
};

export default PrivateRoute;

